@import '../../theme/global';

snap-global-header {
  display: block;
  left: 0;
  position: absolute;
  right: 0;
  z-index: 10001;

  @media (min-width: map-get($breakpoints, 'md')) {
    position: fixed;
  }
}

.snap-global-header {
  align-items: center;
  background-color: $base-light;
  box-sizing: border-box;
  display: flex;
  height: 48px;
  justify-content: space-between;
  padding: 4px 16px;

  @media (min-width: map-get($breakpoints, 'md')) {
    height: 56px;
    padding: 8px 16px 8px 24px;
  }

  @media (min-width: map-get($breakpoints, 'lg')) {
    padding: 8px 24px;
  }

  &--mobile {
    background: radial-gradient(66.41% 1314.55% at 0% 0%, #15339B 49.94%, #1269C1 85.67%);
  }

  &--connect {
    background-color: $product-connect;
  }

  &--drive {
    background-color: $product-drive;
  }

  &--insights {
    background-color: $product-insights;
  }

  &--manage {
    background-color: $product-manage;
  }

  &--raise {
    background-color: $product-raise;
  }

  &--sites {
    background-color: $product-sites;
  }

  &--spend {
    background-color: $product-spend;
  }

  &--sponsor {
    background-color: $product-sponsor;
  }

  &--store {
    background-color: $product-store;
  }

  &--wallet {
    background-color: $product-wallet;
  }

  snap-logo[variant="1line"] {
    .snap-logo {
      height: 25px;
    }
  }

  snap-logo[variant="compact"] {
    .snap-logo {
      height: 40px;
    }
  }

  snap-logo[variant="stacked"] {
    .snap-logo {
      height: 30px;
    }
  }

  snap-app-switcher {
    margin-right: 24px;
  }

  snap-logo-header-end {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  snap-app-switcher-container {
    display: flex;
    position: relative;
  }
}
